var map = {
	"./AD.svg": 61232,
	"./AE.svg": 86371,
	"./AF.svg": 43162,
	"./AG.svg": 65353,
	"./AI.svg": 66250,
	"./AL.svg": 37264,
	"./AM.svg": 49462,
	"./AO.svg": 72525,
	"./AR.svg": 28602,
	"./AS.svg": 73666,
	"./AT.svg": 34657,
	"./AU.svg": 41769,
	"./AW.svg": 34169,
	"./AX.svg": 90148,
	"./AZ.svg": 50518,
	"./BA.svg": 35349,
	"./BB.svg": 3321,
	"./BD.svg": 26834,
	"./BE.svg": 23286,
	"./BEFR.svg": 22842,
	"./BENL.svg": 68673,
	"./BF.svg": 26551,
	"./BG.svg": 93801,
	"./BH.svg": 25423,
	"./BI.svg": 71375,
	"./BJ.svg": 94592,
	"./BM.svg": 82528,
	"./BN.svg": 27253,
	"./BO.svg": 66860,
	"./BQ.svg": 3586,
	"./BR.svg": 90489,
	"./BS.svg": 34117,
	"./BT.svg": 43247,
	"./BW.svg": 3200,
	"./BY.svg": 14900,
	"./BZ.svg": 49404,
	"./CA.svg": 33866,
	"./CAFR.svg": 50804,
	"./CC.svg": 87582,
	"./CD.svg": 33559,
	"./CF.svg": 88604,
	"./CG.svg": 64814,
	"./CH.svg": 46179,
	"./CI.svg": 65495,
	"./CK.svg": 34239,
	"./CL.svg": 1765,
	"./CM.svg": 93376,
	"./CN.svg": 98705,
	"./CO.svg": 47997,
	"./CR.svg": 86134,
	"./CS.svg": 79060,
	"./CU.svg": 11735,
	"./CV.svg": 96420,
	"./CW.svg": 70839,
	"./CX.svg": 98506,
	"./CY.svg": 60179,
	"./CZ.svg": 56082,
	"./DE.svg": 33059,
	"./DJ.svg": 10489,
	"./DK.svg": 19758,
	"./DM.svg": 19535,
	"./DO.svg": 54202,
	"./DZ.svg": 33121,
	"./EC.svg": 51070,
	"./EE.svg": 29477,
	"./EG.svg": 34428,
	"./EM.svg": 15129,
	"./EN.svg": 48022,
	"./ER.svg": 17486,
	"./ES.svg": 3337,
	"./ET.svg": 95125,
	"./FI.svg": 8934,
	"./FJ.svg": 98950,
	"./FK.svg": 76425,
	"./FM.svg": 14432,
	"./FO.svg": 6835,
	"./FR.svg": 18677,
	"./GA.svg": 29935,
	"./GB.svg": 26781,
	"./GD.svg": 13234,
	"./GE.svg": 81852,
	"./GF.svg": 37013,
	"./GG.svg": 98006,
	"./GH.svg": 73763,
	"./GI.svg": 39787,
	"./GL.svg": 75587,
	"./GM.svg": 88033,
	"./GN.svg": 13262,
	"./GP.svg": 22641,
	"./GQ.svg": 31057,
	"./GR.svg": 76827,
	"./GS.svg": 79929,
	"./GT.svg": 636,
	"./GU.svg": 61935,
	"./GW.svg": 58793,
	"./GY.svg": 91999,
	"./HK.svg": 32672,
	"./HN.svg": 96694,
	"./HR.svg": 96762,
	"./HT.svg": 57499,
	"./HU.svg": 25200,
	"./ID.svg": 97988,
	"./IE.svg": 7721,
	"./IL.svg": 69602,
	"./IM.svg": 2621,
	"./IN.svg": 67031,
	"./IO.svg": 28520,
	"./IQ.svg": 42357,
	"./IR.svg": 91401,
	"./IS.svg": 96690,
	"./IT.svg": 54547,
	"./JE.svg": 82364,
	"./JM.svg": 8000,
	"./JO.svg": 5011,
	"./JP.svg": 80567,
	"./KE.svg": 77375,
	"./KG.svg": 32573,
	"./KH.svg": 23409,
	"./KI.svg": 47859,
	"./KM.svg": 40469,
	"./KN.svg": 92760,
	"./KP.svg": 47180,
	"./KR.svg": 90977,
	"./KW.svg": 56055,
	"./KY.svg": 21195,
	"./KZ.svg": 88899,
	"./LA.svg": 39486,
	"./LB.svg": 85293,
	"./LC.svg": 67963,
	"./LI.svg": 203,
	"./LK.svg": 43634,
	"./LR.svg": 60294,
	"./LS.svg": 80645,
	"./LT.svg": 63095,
	"./LU.svg": 1118,
	"./LV.svg": 31146,
	"./LY.svg": 74738,
	"./MA.svg": 18178,
	"./MC.svg": 90744,
	"./MD.svg": 10841,
	"./ME.svg": 18487,
	"./MG.svg": 2639,
	"./MH.svg": 25836,
	"./MK.svg": 82016,
	"./ML.svg": 82934,
	"./MM.svg": 31978,
	"./MN.svg": 77374,
	"./MO.svg": 10302,
	"./MP.svg": 15132,
	"./MQ.svg": 47658,
	"./MR.svg": 45723,
	"./MS.svg": 24766,
	"./MT.svg": 41670,
	"./MU.svg": 69898,
	"./MV.svg": 32040,
	"./MW.svg": 16605,
	"./MX.svg": 79182,
	"./MY.svg": 44329,
	"./MZ.svg": 97928,
	"./NA.svg": 82717,
	"./NC.svg": 17469,
	"./NE.svg": 26997,
	"./NF.svg": 17197,
	"./NG.svg": 88307,
	"./NI.svg": 28610,
	"./NL.svg": 89790,
	"./NO.svg": 4549,
	"./NP.svg": 56309,
	"./NR.svg": 79282,
	"./NU.svg": 45441,
	"./NZ.svg": 99063,
	"./OM.svg": 16302,
	"./PA.svg": 88641,
	"./PE.svg": 12623,
	"./PF.svg": 75618,
	"./PG.svg": 57836,
	"./PH.svg": 94979,
	"./PK.svg": 4615,
	"./PL.svg": 82458,
	"./PM.svg": 43986,
	"./PN.svg": 36346,
	"./PR.svg": 93812,
	"./PS.svg": 57441,
	"./PT.svg": 8192,
	"./PW.svg": 16762,
	"./PY.svg": 9265,
	"./QA.svg": 78594,
	"./RO.svg": 18546,
	"./RS.svg": 37102,
	"./RU.svg": 61647,
	"./RW.svg": 54500,
	"./SA.svg": 35874,
	"./SB.svg": 71203,
	"./SC.svg": 70579,
	"./SD.svg": 7528,
	"./SE.svg": 39877,
	"./SG.svg": 9168,
	"./SH.svg": 91982,
	"./SI.svg": 62260,
	"./SK.svg": 29350,
	"./SL.svg": 1487,
	"./SM.svg": 4606,
	"./SN.svg": 73724,
	"./SO.svg": 62613,
	"./SR.svg": 30764,
	"./ST.svg": 92594,
	"./SV.svg": 47739,
	"./SY.svg": 78663,
	"./SZ.svg": 65926,
	"./TC.svg": 80201,
	"./TD.svg": 40970,
	"./TF.svg": 14465,
	"./TG.svg": 31586,
	"./TH.svg": 81418,
	"./TJ.svg": 21993,
	"./TK.svg": 6714,
	"./TL.svg": 11163,
	"./TM.svg": 96240,
	"./TN.svg": 12731,
	"./TO.svg": 82159,
	"./TR.svg": 16725,
	"./TT.svg": 93481,
	"./TV.svg": 2989,
	"./TZ.svg": 19945,
	"./UA.svg": 48367,
	"./UG.svg": 26569,
	"./UK.svg": 48148,
	"./US.svg": 56908,
	"./UY.svg": 7282,
	"./UZ.svg": 86439,
	"./VA.svg": 929,
	"./VC.svg": 65967,
	"./VE.svg": 68167,
	"./VG.svg": 90974,
	"./VI.svg": 11544,
	"./VN.svg": 4187,
	"./VU.svg": 14518,
	"./WF.svg": 24133,
	"./WS.svg": 94188,
	"./YE.svg": 53893,
	"./YT.svg": 26472,
	"./ZA.svg": 71150,
	"./ZM.svg": 83054,
	"./ZW.svg": 92046,
	"./areas/EU.svg": 96795,
	"./areas/NA.svg": 37402,
	"./areas/RW.svg": 92578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11049;